import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {ProductParameterInner} from './model';

export interface ProductParameterInnerState extends EntityState<ProductParameterInner> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ProductParameterInner' })
export class Store extends EntityStore<ProductParameterInnerState> {

  constructor() {
    super();
  }

}
